module.exports = [
  {
    title: 'Наименование',
    key: 'name'
  },
  {
    title: 'Название лабораторного теста',
    key: 'parameter_name'
  },
  {
    title: 'Код ФСЛИ',
    key: 'lab_test_text'
  }
]
